import { useDrag, useDrop } from 'react-dnd';

const getHoverMiddle = (hoverBoundingRect: any, direction: any) => {
  if (direction === 'row') {
    return (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
  }
  return (hoverBoundingRect.left - hoverBoundingRect.right) / 2;
};

const getHoverClient = (clientOffset: any, hoverBoundingRect: any, direction: any) => {
  if (direction === 'row') {
    return clientOffset.y - hoverBoundingRect.top;
  }

  return clientOffset.x - hoverBoundingRect.right;
};

export const useDragNDropSort = ({ ref, index, id, moveCard, direction }: any) => {
  const [{ handlerId }, drop] = useDrop({
    accept: 'card',
    collect(monitor) {
      return {
        handlerId: monitor.getHandlerId(),
      };
    },
    hover(item: any, monitor) {
      if (!ref.current) {
        return;
      }
      const dragIndex = item.index;
      const hoverIndex = index;
      // Don't replace items with themselves
      if (dragIndex === hoverIndex) {
        return;
      }
      // Determine rectangle on screen
      // @ts-ignore: Unreachable code error
      const hoverBoundingRect = ref.current?.getBoundingClientRect();
      // Get vertical middle
      const hoverMiddle = getHoverMiddle(hoverBoundingRect, direction);
      // Determine mouse position
      const clientOffset = monitor.getClientOffset();

      if (!clientOffset) return;
      // Get pixels to the top
      const hoverClient = getHoverClient(clientOffset, hoverBoundingRect, direction);
      // Only perform the move when the mouse has crossed half of the items height
      // When dragging downwards, only move when the cursor is below 50%
      // When dragging upwards, only move when the cursor is above 50%
      // Dragging downwards
      if (dragIndex < hoverIndex && hoverClient < hoverMiddle) {
        return;
      }
      // Dragging upwards
      if (dragIndex > hoverIndex && hoverClient > hoverMiddle) {
        return;
      }
      // Time to actually perform the action
      moveCard(dragIndex, hoverIndex);
      // Note: we're mutating the monitor item here!
      // Generally it's better to avoid mutations,
      // but it's good here for the sake of performance
      // to avoid expensive index searches.
      item.index = hoverIndex;
    },
  });

  const [{ isDragging }, drag] = useDrag({
    type: 'card',
    item: () => {
      return { id, index };
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  return { handlerId, drop, isDragging, drag };
};
